import { AssetLoader } from "@/game/libs/engine/loader/asset-loader";

export default function addLoaderAssets(loader: AssetLoader) {
  addImageAsset(loader, "animations", "EOTP_Skier");
  addImageAsset(loader, "animations", "EOTP_playbutton");
  addImageAsset(loader, "animations", "EOTP_flag_green");
  addImageAsset(loader, "animations", "EOTP_obstacle_flag");
  addImageAsset(loader, "animations", "EOTP_yeti");
  addImageAsset(loader, "animations", "EOTP_skier_shadow_idle");
  addImageAsset(loader, "animations", "EOTP_logo");

  addSoundAsset(loader, "jump");
  addSoundAsset(loader, "hit_checkMark");
  addSoundAsset(loader, "hit_youUp");
  addSoundAsset(loader, "hit_redFlag");
  addSoundAsset(loader, "hit_baggage");
  addSoundAsset(loader, "hit_tree");
  addSoundAsset(loader, "hit_MTV");
  addSoundAsset(loader, "yetiDeath");
  addSoundAsset(loader, "obstacleDeath");
  addSoundAsset(loader, "land");
  addSoundAsset(loader, "stop");

  loader.addSound("track", [require(`@/assets/game/sounds/bg/track.mp3`)]);

  addImageAsset(loader, "tunein", "Thurs_Dec_5_at_9_8c");
  addImageAsset(loader, "tunein", "Thursdays_at_9_8c");
  addImageAsset(loader, "tunein", "TONIGHT_at_9_8c");

  addImageAsset(loader, "bg", "EOTP_lodge");
  addImageAsset(loader, "bg", "EOTP_snow_tile");
  addImageAsset(loader, "obstacles", "EOTP_obstacle_baggage1");
  addImageAsset(loader, "obstacles", "EOTP_obstacle_baggage2");
  addImageAsset(loader, "obstacles", "EOTP_obstacle_baggage3");
  addImageAsset(loader, "obstacles", "EOTP_obstacle_sign");
  addImageAsset(loader, "obstacles", "EOTP_obstacle_text1");
  addImageAsset(loader, "obstacles", "EOTP_obstacle_text2");
  addImageAsset(loader, "obstacles", "EOTP_obstacle_tree");
  addImageAsset(loader, "ui", "EOTP_HUD_fullheart");
  addImageAsset(loader, "ui", "EOTP_HUD_brokenheart");
  addImageAsset(loader, "ui", "EOTP_HUD_help");
  addImageAsset(loader, "ui", "EOTP_HUD_leaderboard");
}

function addImageAsset(
  loader: AssetLoader,
  folder: string,
  name: string
): void {
  loader.addTexture(
    name,
    require(`@/assets/game/images/${folder}/${name}.png`)
  );
}

function addSoundAsset(loader: AssetLoader, name: string): void {
  loader.addSound(name, [require(`@/assets/game/sounds/${name}.mp3`)]);
}
